import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICustomerStatusChangeFilterFormMeta {
  agency: FormInputMeta;
  client: FormInputMeta;
  pan: FormInputMeta;

  schema: any;
}

const customerStatusChangeFilterFormMeta = {} as ICustomerStatusChangeFilterFormMeta;

customerStatusChangeFilterFormMeta.agency = {
  name: "agency",
  type: "select",
  label: "Agence",
  options: [
    {
      label: "agency 1",
      value: "agency-1"
    },
    {
      label: "agency 2",
      value: "agency-2"
    },
  ],
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

customerStatusChangeFilterFormMeta.client = {
  name: "client",
  type: "select",
  label: "Client",
  options: [
    {
      label: "client 1",
      value: "client-1"
    },
    {
      label: "client 2",
      value: "client-2"
    },
  ],
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

customerStatusChangeFilterFormMeta.schema = yup.object().shape(getValidationSchema(customerStatusChangeFilterFormMeta));

export default customerStatusChangeFilterFormMeta;